const assetActions = [
  {
    label: "Открыть/Редактировать",
    onClick: (id, handlers) => {
      // Сохраняем ID актива для скролла при возврате
      localStorage.setItem("lastViewedAssetId", id.toString());
      
      // Переход на объединенную страницу редактирования актива с AI полями
      if (handlers && handlers.navigate) {
        handlers.navigate(`/assets/edit/${id}`);
      } else {
        window.location.href = `/assets/edit/${id}`;
      }
    },
    color: "primary",
    condition: (row) => true,
    tooltip: "Открыть или редактировать актив с AI полями",
  },
  {
    label: "Копировать",
    onClick: (id, handlers) => handlers.onCopy(id),
    color: "blue",
    condition: (row) => true,
    tooltip: "Скопировать этот актив",
  },
  {
    label: "Удалить",
    onClick: (id, handlers) => handlers.onPermanentDelete(id),
    color: "red",
    tooltip: "Полностью удалить актив",
  },
];

export default assetActions; // Экспортируем массив
